const locale = "nl-NL";
const translations = {
	timeFormat: "HH:mm",
	dateFormat: "DD.MM.YYYY",
	dateTimeFormat: "DD.MM.YYYY HH:mm",
	"serviceReports.headline": "Serviceberichten",
	"serviceReports.sublineMachine": "Raadpleeg de servicerapporten van uw machine en download ze hier.",
	"serviceReports.technicianName": "Naam monteur",
	"serviceReports.machineNameAndNumber": "Machine & machinenr.",
	"serviceReports.startDate": "Van",
	"serviceReports.endDate": "Tot",
	"serviceReports.creationDate": "Opsteldatum",
	"serviceReports.openReport": "Servicebericht openen (pdf-bestand)",
	"serviceReports.filter": "Filter",
	"serviceReports.missionNumber": "Missienummer",
	"serviceReports.assignmentType": "Type servicerapport",
	"serviceReports.reportTypes.IA": "Demontage- en omschakelingsrapport",
	"serviceReports.reportTypes.AC": "Rapport toepassingsadvies",
	"serviceReports.reportTypes.IV": "Rapport installatievoorbereiding",
	"serviceReports.reportTypes.BA": "Rapport bestandopname",
	"serviceReports.reportTypes.UV": "Rapport veiligheidscontrole",
	"serviceReports.reportTypes.IG": "Montagerapport gebruikte machine",
	"serviceReports.reportTypes.UB": "Rapport kwaliteitsmaatregel",
	"serviceReports.reportTypes.PN": "Rapport productiebegeleiding",
	"serviceReports.reportTypes.NR": "Rapport aanvullende functie",
	"serviceReports.reportTypes.IB": "Installatie- en opstartrapport",
	"serviceReports.reportTypes.II": "Integratierapport installatie",
	"serviceReports.reportTypes.IC": "Rapport interne reparatie",
	"serviceReports.reportTypes.MB": "Rapport beurscontact",
	"serviceReports.reportTypes.HW": "Ressourcerapport",
	"serviceReports.reportTypes.TT": "Rapport monteurtraining",
	"serviceReports.reportTypes.SK": "Rapport klantopleiding",
	"serviceReports.reportTypes.RP": "Reparatierapport",
	"serviceReports.reportTypes.RW": "Reparatie- en onderhoudsrapport",
	"serviceReports.reportTypes.WA": "Onderhoudsrapport",
	"serviceReports.reportTypesPlural.IA": "Demontage- en omschakelingsrapporten",
	"serviceReports.reportTypesPlural.AC": "Rapporten toepassingsadvies",
	"serviceReports.reportTypesPlural.IV": "Rapporten installatievoorbereiding",
	"serviceReports.reportTypesPlural.BA": "Rapporten bestandopnames",
	"serviceReports.reportTypesPlural.UV": "Rapporten veiligheidscontroles",
	"serviceReports.reportTypesPlural.IG": "Montagerapporten gebruikte machines",
	"serviceReports.reportTypesPlural.UB": "Rapporten kwaliteitsmaatregelen",
	"serviceReports.reportTypesPlural.PN": "Rapporten productiebegeleiding",
	"serviceReports.reportTypesPlural.NR": "Rapporten aanvullende functies",
	"serviceReports.reportTypesPlural.IB": "Installatie- en opstartrapporten",
	"serviceReports.reportTypesPlural.II": "Integratierapporten installatie",
	"serviceReports.reportTypesPlural.IC": "Rapporten interne reparaties",
	"serviceReports.reportTypesPlural.MB": "Rapporten beurscontacten",
	"serviceReports.reportTypesPlural.HW": "Ressourcerapporten",
	"serviceReports.reportTypesPlural.TT": "Rapporten monteurstrainingen",
	"serviceReports.reportTypesPlural.SK": "Rapporten klantopleiding",
	"serviceReports.reportTypesPlural.RP": "Reparatierapporten",
	"serviceReports.reportTypesPlural.RW": "Reparatie- en onderhoudsrapporten",
	"serviceReports.reportTypesPlural.WA": "Onderhoudsrapporten",
	"serviceReports.loadMore": "Meer laden",
	"serviceReports.loadError": "Er is een fout opgetreden bij het laden van de gegevens",
	"serviceReports.noReportsFound": "Op dit moment zijn er geen serviceberichten aanwezig.",
	"serviceReports.noReportsAvailable": "Op dit moment zijn er geen serviceberichten aanwezig.",
	missingAuthorization: "Geen rechten",
	"headline.createCase": "Nieuw servicegeval aanmaken",
	"headline.caseDetails": "Details van het geval",
	"headline.contactData": "Contactgegevens",
	"field.reason.label": "Reden voor melding",
	"field.machine.label": "Machine & machinenr.",
	"field.softwareProblemClassification.label": "Probleemclassificatie",
	"field.softwareInstallationProblem.label": "Installatieprobleem",
	"field.softwareLicenseIssue.label": "Licentieprobleem",
	"field.softwareType.label": "Type software",
	"field.softwareModule.label": "Softwaremodule",
	"field.errorNumber.label": "Foutnummers",
	"field.errorNumber.explanation": "bijv. 0000FC00, 1.10.58102409 of 6000",
	"field.errorNumber.addAnotherNumber": "Meer foutnummers toevoegen",
	"field.errorNumber.errorMessage": "Ongeldige foutnummers",
	"field.message.label": "Bericht",
	"field.message.placeholder": "Beschrijf (zonder begroeting) zo concreet en gedetailleerd mogelijk uw probleem. Hartelijk bedankt.",
	"field.fileUpload.label": "Bijlagen",
	"field.fileUpload.info": "Toegestane bestandsformaten: IMG, JPG, PNG, PDF, HTML, TruTops-bestanden etc. (max. 16 MB) en MP4 videobestanden (max. 50 MB)",
	"field.salutation.label": "Aanhef",
	"field.salutation.male": "De heer",
	"field.salutation.female": "Mevrouw",
	"field.firstName.label": "Voornaam",
	"field.lastName.label": "Achternaam",
	"field.email.label": "E-mail",
	"field.phone.label": "Telefoonnummer",
	"button.submit": "Versturen",
	"button.cancel": "Annuleren",
	"button.back": "terug",
	"button.next": "verder",
	"button.close": "Sluiten",
	"button.ok": "OK",
	"auth.error": "Er is een onverwachte fout opgetreden.",
	"select.placeholder": "Selecteer...",
	"validation.requiredField": "Dit veld is een verplicht veld",
	"validation.invalidEmail": "Vul een geldig e-mailadres in",
	"validation.maxAllowedCharacters": "Maximaal toegestane aantal tekens: {{number}}",
	"validation.requiredFieldsExplanation": "Verplichte velden zijn met een * (asterisk) aangeduid.",
	"validation.invalidPhoneNumber": "Vul een geldig telefoonnummer in.",
	"softwareProblemClassification.standstill": "Stilstand",
	"softwareProblemClassification.fault": "Storing",
	"softwareProblemClassification.slightImpairment": "Lichte aantasting",
	"softwareProblemClassification.generalInquiry": "Algemene aanvraag",
	"serviceCase.proactiveCaseClosure.title": "Feedback & aanvraag voor sluiting van het geval",
	"serviceCase.proactiveCaseClosure.instructions": "Om sluiting van het geval aan te vragen en ons te helpen om onze Predictive Service te verbeteren, vragen we uw feedback.",
	"serviceCase.proactiveCaseClosure.question.submit": "Versturen",
	"serviceCase.proactiveCaseClosure.dialogTitle": "Sluiting geval aangevraagd. Bedankt voor uw feedback.",
	"serviceCase.proactiveCaseClosure.dialog.buttonOk": "OK",
	"serviceCase.proactiveCaseClosure.question.anomaly": "Was de gemelde afwijking aanwezig op uw machine?",
	"serviceCase.proactiveCaseClosure.question.technicalGuideLinked": "Werd een Technical Guide ter beschikking gesteld?",
	"serviceCase.proactiveCaseClosure.question.technicalGuideHelpful": "Hebt u het probleem zelf met behulp van de Technical Guides kunnen oplossen?",
	"serviceCase.proactiveCaseClosure.question.pauseRequest": "Wilt u meldingen voor dit type afwijking pauzeren?",
	"serviceCase.proactiveCaseClosure.question.pauseRequestDuration": "Hoelang wilt u meldingen voor dit type afwijking pauzeren?",
	"serviceCase.proactiveCaseClosure.question.comment": "Leg uit waarom u meldingen voor dit type afwijking wilt pauzeren:",
	"serviceCase.proactiveCaseClosure.question.commentPlaceholder": "De uitleg is verplicht om de sluiting van het geval aan te vragen en feedback te sturen",
	"serviceCase.proactiveCaseClosure.answers.yes": "Ja",
	"serviceCase.proactiveCaseClosure.answers.no": "Nee",
	"serviceCase.proactiveCaseClosure.answers.sevenDays": "7 dagen",
	"serviceCase.proactiveCaseClosure.answers.fourteenDays": "14 dagen",
	"serviceCase.proactiveCaseClosure.answers.thirtyDays": "30 dagen",
	"serviceCase.proactiveCaseClosure.answers.ninetyDays": "90 dagen",
	"sisConnector.success.headline": "Servicegeval is met succes aangemaakt.",
	"sisConnector.success.orderNumberRequired.title": "Opmerking:",
	"sisConnector.success.orderNumberRequired.text": "Voeg op de gevaldetailpagina een bestelnummer toe voor het factureren van het geval en verdere services.",
	"sisConnector.success.technicalGuide.title": "Voor dit foutnummer/deze foutnummers is een Technical Guide beschikbaar.",
	"sisConnector.success.technicalGuide.text": "Aan de hand van de ingevoerde foutnummer(s) kan (kunnen) een of meerdere Technical Guide(s) worden geraadpleegd. In ca. 50% van de gevallen bent u nu in staat het probleem zelf op te lossen. Deze functie is alleen met het bijbehorende servicecontract beschikbaar.",
	"sisConnector.success.outsideOfServiceHours": "Houd er rekening mee dat gevallen die buiten onze servicetijden worden aangemaakt, niet in behandeling worden genomen.",
	"sisConnector.success.serviceTimes.MonFri": "Onze servicetijden zijn: maandag t/m vrijdag",
	"sisConnector.success.serviceTimes.Sat": "en zaterdag",
	"sisConnector.success.withTechnicalServiceHotline": "Als u direct ondersteuning nodig hebt, kunt u de technische klantenservice van TRUMPF ({{hotline}}) bellen.",
	"sisConnector.success.withoutTechnicalServiceHotline": "Als u direct ondersteuning nodig hebt, kunt u de technische klantenservice van TRUMPF bellen.",
	"sisConnector.success.caseId": "Aanvraagnummer",
	"sisConnector.failed.headline": "Het servicegeval kon niet woden aangemaakt.",
	"sisConnector.failed.unknownError": "Probeer het opnieuw of neem contact op met uw support."
};
var nlNL = {
	locale: locale,
	translations: translations
};

export { nlNL as default, locale, translations };
//# sourceMappingURL=nl-NL-D38z6Eeg.js.map

//# sourceMappingURL=nl-NL-D38z6Eeg.js.map